<template>
    <comp-9-art-adherence :section="9" :page="64" :nextDisabled="nextDisabled">
        <p>
            Here are some ideas and strategies people use to help them take ART regularly. Put a checkmark next to items that you think might work for you. You
            can also add your own strategies.
        </p>
        <v-checkbox
            v-for="strategy in artStrategies"
            :key="strategy.id"
            :label="strategy.text"
            :value="strategy.id"
            v-model="selectedStrategies"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedStrategyResponse"></v-text-field>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedStrategies: [],
            selectedStrategyResponse: null
        };
    },
    computed: {
        artSelectedStrategies() {
            let artSelectedStrategies = map(filter(this.artStrategies, 'selected'), 'id');

            if (artSelectedStrategies) {
                return artSelectedStrategies;
            } else return [];
        },
        artSelectedStrategyResponse() {
            let userEnteredStrategy = filter(filter(this.artStrategies, 'selected'), 'userEntered');

            if (userEnteredStrategy.length > 0) {
                return userEnteredStrategy[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.artStrategies, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        artStrategies: sync('section9/artRegularStrategies')
    },
    methods: {
        nextDisabled() {
            if (this.selectedStrategies.length === 0 || (this.showManualResponse && !this.selectedStrategyResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedStrategies() {
            forEach(this.artStrategies, o => {
                if (this.selectedStrategies.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedStrategyResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedStrategyResponse() {
            forEach(this.artStrategies, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedStrategyResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedStrategies = this.artSelectedStrategies;
        this.selectedStrategyResponse = this.artSelectedStrategyResponse;
    }
};
</script>
